import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-3 gap-8 relative" }
const _hoisted_4 = { class: "w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-brand-100 flex items-center justify-center mb-5 relative z-10 ring-4 ring-white" }
const _hoisted_5 = { class: "text-3xl sm:text-4xl" }
const _hoisted_6 = { class: "absolute -top-2 -right-2 w-6 h-6 sm:w-7 sm:h-7 bg-brand text-white rounded-full text-xs font-bold flex items-center justify-center font-display" }
const _hoisted_7 = { class: "font-display font-bold text-accent text-lg mb-2" }
const _hoisted_8 = { class: "text-accent/60 text-sm leading-relaxed max-w-xs" }
const _hoisted_9 = { class: "text-center mt-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-center max-w-xl mx-auto mb-8 sm:mb-12" }, [
        _createElementVNode("p", { class: "text-brand font-semibold text-sm uppercase tracking-widest mb-1" }, "Simple & Easy"),
        _createElementVNode("h2", { class: "section-title" }, "How It Works"),
        _createElementVNode("p", { class: "section-subtitle" }, " From your door to ours — order in 3 easy steps ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "hidden md:block absolute top-12 left-1/3 right-1/3 h-0.5 bg-brand-200 -z-0" }, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: step.title,
            class: "flex flex-col items-center text-center relative"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(step.emoji), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(index + 1), 1)
            ]),
            _createElementVNode("h3", _hoisted_7, _toDisplayString(step.title), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(step.description), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          to: "/menu",
          class: "btn-primary text-base px-10 py-3"
        }, {
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createTextVNode(" Start Your Order ", -1)),
            _createVNode(_component_ArrowRightIcon, { class: "w-5 h-5" })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}